import request from "../utils/request";

export function getThongBao(params) {
  return request({
    url: "thongbaoweb",
    method: "get",
    params,
  });
}

export function docThongBao(data) {
  return request({
    url: "docthongbao",
    method: "put",
    data,
  });
}

export function thongBaoNghi(params) {
  return request({
    url: "thongbaonghi",
    method: "get",
    params,
  });
}